const env = {
  REACT_APP_BACKEND_URL: process.env.REACT_APP_BACKEND_URL || "",
  REACT_APP_FACEBOOK_APP_ID: process.env.REACT_APP_FACEBOOK_APP_ID || "",
  REACT_APP_REQUIRE_BUSINESS_MANAGEMENT: (process.env.REACT_APP_REQUIRE_BUSINESS_MANAGEMENT || "FALSE").toUpperCase() === "TRUE",
  REACT_APP_NAME_SYSTEM: process.env.REACT_APP_NAME_SYSTEM || "ChatIA",
  REACT_APP_NUMBER_SUPPORT: process.env.REACT_APP_NUMBER_SUPPORT || "",
  REACT_APP_HOURS_CLOSE_TICKETS_AUTO: process.env.REACT_APP_HOURS_CLOSE_TICKETS_AUTO || "9999",
  REACT_APP_PRIMARY_COLOR: process.env.REACT_APP_PRIMARY_COLOR || "#34637C",
  REACT_APP_PRIMARY_DARK: process.env.REACT_APP_PRIMARY_DARK || "#5A6C9B"
};
export default env;
export const BACKEND_URL = env.REACT_APP_BACKEND_URL;
export const FACEBOOK_APP_ID = env.REACT_APP_FACEBOOK_APP_ID;
export const REQUIRE_BUSINESS_MANAGEMENT = env.REACT_APP_REQUIRE_BUSINESS_MANAGEMENT;
export const NAME_SYSTEM = env.REACT_APP_NAME_SYSTEM;
export const NUMBER_SUPPORT = env.REACT_APP_NUMBER_SUPPORT;
export const HOURS_CLOSE_TICKETS_AUTO = env.REACT_APP_HOURS_CLOSE_TICKETS_AUTO;
export const PRIMARY_COLOR = env.REACT_APP_PRIMARY_COLOR;
export const PRIMARY_DARK = env.REACT_APP_PRIMARY_DARK;
